import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Players from './pages/Players';
import Player from './pages/Player';
import Tournaments from './pages/Tournaments';
import Tournament from './pages/Tournament';
import Clubs from './pages/Clubs';
import ClubDetails from './pages/ClubDetails';
import Bookings from './pages/Bookings';
import Trainers from './pages/Trainers';
import Rankings from './pages/Rankings';
import Matches from './pages/Matches';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <div className="App">
          <Navigation />
          <div className="App-content">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              {/* Protected Routes */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              } />
              <Route path="/players" element={
                <PrivateRoute>
                  <Players />
                </PrivateRoute>
              } />
              <Route path="/player/:id" element={
                <PrivateRoute>
                  <Player />
                </PrivateRoute>
              } />
              <Route path="/tournaments" element={
                <PrivateRoute>
                  <Tournaments />
                </PrivateRoute>
              } />
              <Route path="/tournament/:id" element={
                <PrivateRoute>
                  <Tournament />
                </PrivateRoute>
              } />
              <Route path="/clubs" element={
                <PrivateRoute>
                  <Clubs />
                </PrivateRoute>
              } />
              <Route path="/club/:slug" element={
                <PrivateRoute>
                  <ClubDetails />
                </PrivateRoute>
              } />
              <Route path="/bookings" element={
                <PrivateRoute>
                  <Bookings />
                </PrivateRoute>
              } />
              <Route path="/trainers" element={
                <PrivateRoute>
                  <Trainers />
                </PrivateRoute>
              } />
              <Route path="/rankings" element={
                <PrivateRoute>
                  <Rankings />
                </PrivateRoute>
              } />
              <Route path="/matches" element={
                <PrivateRoute>
                  <Matches />
                </PrivateRoute>
              } />
            </Routes>
          </div>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
